import { render, staticRenderFns } from "./bfhs-button.vue?vue&type=template&id=7b92a169&"
import script from "./bfhs-button.vue?vue&type=script&lang=js&"
export * from "./bfhs-button.vue?vue&type=script&lang=js&"
import style0 from "./bfhs-button.vue?vue&type=style&index=0&id=7b92a169&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports